export default __webpack_public_path__ + "static/media/eventdata.82f8f060.png";